import React from "react";
import {Redirect, Route, Switch, useParams, useRouteMatch} from "react-router-dom";
import OfflinePageQRCode from "./OfflinePageQRCode";
import {useEventContext} from "../../../context";

const OfflinePageQRCodeRoute = () => {
    const {event} = useEventContext();
    const {streamKey, moduleName, parameter, value} = useParams();

    let stream = null;
    if (streamKey) {
        stream = event.stream.find((stream) => stream.streamKey === streamKey);
    }

    let argument;
    if (parameter) {
        argument = `${parameter}=${value}`;
    }

    return (
        <OfflinePageQRCode stream={stream} moduleName={moduleName} argument={argument} />
    );
}

export default () => {
    const {path, url} = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/stream/:streamKey/qr/:moduleName/:parameter/:value`}>
                <OfflinePageQRCodeRoute />
            </Route>
            <Route path={`${path}/stream/:streamKey/qr/:moduleName`}>
                <OfflinePageQRCodeRoute />
            </Route>
            <Route path={`${path}/qr/:moduleName/:parameter/:value`}>
                <OfflinePageQRCodeRoute />
            </Route>
            <Route path={`${path}/stream/:streamKey/qr`}>
                <OfflinePageQRCodeRoute />
            </Route>
            <Route path={`${path}/qr`}>
                <OfflinePageQRCodeRoute />
            </Route>
            <Redirect to={`${url}/qr`} />
        </Switch>
    )
}
